import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select, Stack, Text } from "@mantine/core";
import { FormattedMessage, useIntl } from "react-intl";
import { horizontalWrapperProps } from "../../utils/style.js";
import { useMemo } from "react";
import { getSourceLayers } from "../../utils/layer.js";
import { useAppSelector } from "../../hooks/redux.js";
import { getSourcesIds } from "../../reducers/sourcesReducer.js";
export const LayerDataSource = ({ sourceInfo, sourceLayerId }) => {
    const intl = useIntl();
    const sources = useAppSelector(getSourcesIds);
    const sourceOptions = useMemo(() => {
        return sources.map(id => ({
            value: id,
            label: id,
        }));
    }, [sources]);
    const sourceLayersOptions = useMemo(() => {
        const sourceLayers = getSourceLayers(sourceInfo);
        return sourceLayers.map(({ id }) => ({
            value: id,
            label: id,
        }));
    }, [sourceInfo]);
    return (_jsxs(Stack, { px: "sm", children: [_jsx(Text, { fz: "sm", fw: "bold", children: _jsx(FormattedMessage, { id: "label.source", defaultMessage: "Source" }) }), _jsx(Select, { wrapperProps: horizontalWrapperProps, size: "xs", label: intl.formatMessage({
                    defaultMessage: "Data source",
                    id: "label.dataSource",
                }), value: sourceInfo?.sourceId, data: sourceOptions }), _jsx(Select, { wrapperProps: horizontalWrapperProps, size: "xs", label: intl.formatMessage({
                    defaultMessage: "Data layer",
                    id: "label.dataLayer",
                }), value: sourceLayerId, data: sourceLayersOptions })] }));
};
